import MemberView from "./MemberView";
import { useMemberManager } from "../hooks/useMemberManager";

export default function RoomView() {
    const { members } = useMemberManager();
    const Width = window.innerWidth
    return (
        <>
            <div className={`overflow-auto flex flex-wrap w-full h-full justify-center items-center relative`}>
                {members.slice(0, Width > 640 ? 9 : 6).map((member, index) => (
                    <>
                        <div key={member.pubkey} className={`${member?.is_local && members?.length > 9 && "hidden"}  ${members.length <= 2 ? "w-full h-1/2  flex items-center lg:h-full lg:w-1/2" : "w-6/12 h-2/4"} ${members.length > 4 && "!h-1/3  lg:!h-1/2 lg:w-4/12"} ${members.length === 4 && "lg:!h-1/2"} ${members.length === 3 && "lg:w-1/3 lg:!h-full w-full !h-1/3"}  ${members.length >= 6 && "lg:!h-1/2 lg:w-2/6"} ${members?.length >= 7 && "lg:!w-3/12"} ${members?.length === 9 && "lg:!h-1/3 lg:!w-4/12"}  rounded-2xl lg:h-full`}>
                            <MemberView key={member.pubkey} member={member}></MemberView>
                        </div>
                    </>
                ))}
            </div>
        </>
    );
}